import { useT } from "../i18n/index.tsx"
import { DISPOSITIONS } from "../lib/dispositions.ts"
import { FREIGHT_TYPES } from "../lib/freight.ts"
import { RETURN_REASONS } from "../lib/return-reasons.ts"

/**
 * 고르는 값의 보기. 값(코드)은 서버 enum 과 같아야 하고 문구는 언어 사전이 정한다
 * — 화면마다 손으로 적으면 한쪽만 늘어나거나 값이 어긋난다.
 *
 * `<Select>` 안에 넣어 쓴다. 칸 자체의 크기·모양은 화면마다 다르므로 여기서 정하지 않는다.
 */

/** 아직 고르지 않음. 서버는 빈 값을 받지 않으므로 고르기 전에는 보내지 않는다. */
function Placeholder() {
  const t = useT()
  return <option value="">{t("common.select")}</option>
}

/**
 * 착불 · 선불 (`server/src/routes/cases.ts` 의 freightSchema).
 *
 * 고르기 전이라는 보기는 두지 않는다 — 칸이 기본값(착불)으로 서 있고,
 * 선불일 때만 바꿔 고른다(`lib/freight.ts`).
 */
export function FreightOptions() {
  const t = useT()
  return (
    <>
      {FREIGHT_TYPES.map((freightType) => (
        <option key={freightType} value={freightType}>
          {t(`freight.${freightType}`)}
        </option>
      ))}
    </>
  )
}

/** 반품 사유 (`server/src/domain/return-reason.ts`). */
export function ReturnReasonOptions() {
  const t = useT()
  return (
    <>
      <Placeholder />
      {RETURN_REASONS.map((reason) => (
        <option key={reason} value={reason}>
          {t(`reason.${reason}`)}
        </option>
      ))}
    </>
  )
}

/**
 * 한국반송 · 폐기 (`server/src/routes/cases.ts` 의 dispositionSchema).
 *
 * 고르기 전이라는 보기는 두지 않는다 — 칸이 기본값(한국반송)으로 서 있고,
 * 폐기일 때만 바꿔 고른다(`lib/dispositions.ts`).
 */
export function DispositionOptions() {
  const t = useT()
  return (
    <>
      {DISPOSITIONS.map((disposition) => (
        <option key={disposition} value={disposition}>
          {t(`disposition.${disposition}`)}
        </option>
      ))}
    </>
  )
}
